export default (imgData, contrast) => {
    // input range [-100..100]
    const d = imgData.data;
    const contrastDecimal = contrast / 100 + 1; // convert to decimal & shift range: [0..2]
    const intercept = 128 * (1 - contrastDecimal);
    for (let i = 0; i < d.length; i += 4) {
        // r,g,b,a
        d[i] = d[i] * contrastDecimal + intercept;
        d[i + 1] = d[i + 1] * contrastDecimal + intercept;
        d[i + 2] = d[i + 2] * contrastDecimal + intercept;
    }
    return imgData;
};
